class Appearance {
    constructor(json) {
        this.gender = json.gender;
        this.eyes = json.eyes;
        this.hair = json.hair;
        this.skin = json.skin;
        this.height = Number(json.height);
        this.weight = Number(json.weight);
    }
}

export default Appearance;